

import { getPageTitle } from '~/assets/js/seo/title.js';
import { mapGetters } from 'vuex'
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)

export default {

	components: {
	},

	computed: {
		...mapGetters([
			'time'
		]),
	},

	head() {
		let _title = getPageTitle(this.$i18n.locale, '404');
		let _description = 'Sorry, 404 Page not found.';
		return {
			title: _title,
			meta: [
				{
					name: 'description',
					content: _description,
				}
			]
		}
	},

	async fetch ({ store, $http }) {
		if( !store.getters.projects.length ){
			const request = `${envSet.staticUrl}/db/projects.json`;
			const response = await $http.$get( request );
			store.dispatch( 'setProjects', response );
		}
	},

	mounted(){
		ROUTE.onMounted( this.$store.$device, {
			current : { type : 'notfound', slug : 'notfound' },
			prev : null,
			next : null
		});
	},

	transition : {
		mode: 'out-in',
		css: false,
		beforeEnter( el ){
			ROUTE.beforeEnter( el );
		},
		enter( el, done ){
			ROUTE.enter( el, done );
		},
		afterEnter( el ){
			ROUTE.afterEnter( el );
		},
		leave( el, done ){
			ROUTE.leave(el, done);
		},
	}

}
